<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_explore_scout')
}

const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const goToMap = () => {
  router.push('/map')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">Great!</p>
      <p class="pb-2">
        Now, let’s launch your scout ship toward a nearby star. With some luck, we’ll discover new planets there that can be explored and settled.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        <div class="ml-3">
          <ul class="list-decimal">
            <li>Find your homeworld on the map and click on it.</li>
            <li>In the popup, Click on your name in the ship list on the right.</li>
            <li>Find your ship named "Scout" and double click on its name.</li>
            <li>In the action bar select the "move" <GenericIcon type="cmd_move"/> command.</li>
            <li>Find the closest star and click on it.</li>
            <li>Now select "Set" and our scout will automatically fly to the selected star.</li>
          </ul>
        </div>
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2"> Goto Map </ActionButton>
      <ActionButton @click="handleNextStep"> Done! whats next? </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>